// extracted by mini-css-extract-plugin
export default {"MainBtns":"MainBtns_MainBtns__G1aJO","MainBtn":"MainBtns_MainBtn__-25x3"};